import { render } from "./NotificationsCounterMob.vue?vue&type=template&id=6521c749&scoped=true&ts=true"
import script from "./NotificationsCounterMob.vue?vue&type=script&lang=ts"
export * from "./NotificationsCounterMob.vue?vue&type=script&lang=ts"

import "./NotificationsCounterMob.vue?vue&type=style&index=0&id=6521c749&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6521c749"]])

export default __exports__